import ladder_pencil from '@/assets/images/ladder_pencil.png'
import { Flex, Typography } from 'antd'

const { Title, Text } = Typography

const StepThree = () => {
  return (
    <Flex vertical gap="middle" align="center">
      <img src={ladder_pencil} alt="Sucesso" width={178} />

      <Title
        level={1}
        style={{
          fontWeight: 'bold',
          margin: 0,
          textAlign: 'center',
          fontSize: '32px',
        }}
      >
        Sua conta agora é grátis
      </Title>
      <Text
        type="secondary"
        style={{ fontSize: '16px', textAlign: 'center', maxWidth: '75%' }}
      >
        Seus limites de conta foram atualizados, mas seus dados continuam
        seguros conosco. Se quiser ir mais longe,{' '}
        <a href="/lab/plans" style={{ color: '#AD34FE' }}>
          confira nossos planos
        </a>
      </Text>
    </Flex>
  )
}

export default StepThree
